module.exports = __webpack_public_path__ + "img/bv-logo-bw-header-inv.f3040ad3.svg";